// The brand this build is for: `@brand` points at brands/<BRAND>/ (Vite, tsup and vitest set it from
// the BRAND variable, default "neus"; TypeScript checks against brands/neus).
import brandFile from "@brand/brand.json";
import type { Brand, BrandFile } from "./brandSchema";

export type { Brand };

/** BrandSchema's defaults, without loading zod: brands.test.ts checks it gives what the schema gives. */
export const withBrandDefaults = (file: BrandFile): Brand => ({
  ...file,
  site: { ...file.site, indexable: file.site.indexable ?? false },
  departments: file.departments.map((d) => ({ ...d, inMenu: d.inMenu ?? true })),
  demoImageColors: file.demoImageColors ?? {},
});

/** This build's brand (JSON imports type a tuple as an array, so the cast). BrandSchema checks brand.json in the client build and the tests, so a bad one fails both. */
export const BRAND: Brand = withBrandDefaults(brandFile as unknown as BrandFile);
